import network from '@/services/network';
import { NotificationListResponse, UnreadCountResponse } from '@/types';
import { ErrorResponse } from '@/utils';

const getNotifications = async (page = 1, perPage = 20): Promise<NotificationListResponse> => {
  try {
    const { data } = await network.get<NotificationListResponse>('/notifications', {
      params: { page, per_page: perPage },
    });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  try {
    const { data } = await network.get<UnreadCountResponse>('/notifications/unread-count');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const markAsRead = async (id: string): Promise<void> => {
  try {
    await network.post(`/notifications/${id}/read`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const markAllAsRead = async (): Promise<void> => {
  try {
    await network.post('/notifications/read-all');
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const notificationApi = { getNotifications, getUnreadCount, markAsRead, markAllAsRead };
export default notificationApi;
